import MatrixControl from 'leaflet-matrix-layers-control'

import 'leaflet-matrix-layers-control/src/matrixControl.css'

export default MatrixControl
